import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/junk.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/furniture-removal")({
  head: () => ({
    meta: [
      { title: services["furniture-removal"].metaTitle },
      { name: "description", content: services["furniture-removal"].metaDescription },
      { property: "og:title", content: services["furniture-removal"].metaTitle },
      { property: "og:description", content: services["furniture-removal"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/furniture-removal" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/furniture-removal" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Furniture Removal', url: 'https://anchorsrq.com/furniture-removal' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "furniture-removal", name: 'Furniture Removal', serviceType: 'Furniture Removal', description: 'Heavy-lift furniture removal in the Sarasota region — single pieces to whole-home loads carefully extracted and hauled by Anchor Services, with donation-first sorting whenever possible.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["furniture-removal"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["furniture-removal"]} heroImg={heroImg} />,
});
